<script setup lang="ts">
import { MeasureResult } from '../../utils/types';
import MetricBreakdownTile from './MetricBreakdownTile.vue';
import ValueTile from './parts/ValueTile.vue';
import { MetricType } from './utility';

const props = defineProps<{
  title?: string;
  isLoadingIndicator?: boolean;
  metricType?: MetricType;
  slicedValues?: {
    label: string;
    measureResult: MeasureResult;
    metricBreakdown: {
      negative: MeasureResult;
      neutral: MeasureResult;
      positive: MeasureResult;
    };
  }[];
}>();
const { isLoadingIndicator, slicedValues } = toRefs(props);

// we need to determine which of the cards should have the glow - either green or red, for the highest and lowest value
const topPositiveTile = ref('');
const topNegativeTile = ref('');

watchEffect(() => {
  if (isLoadingIndicator.value || !slicedValues.value) {
    return;
  }
  let highestVal: { label: string; val: number } = { label: 'NA', val: 0 };
  let lowestVal: { label: string; val: number } = { label: 'NA', val: 0 };

  slicedValues.value.forEach((v) => {
    if (
      v.measureResult.currentValue &&
      v.measureResult.currentValue > 0 &&
      v.measureResult.currentValue > highestVal.val
    ) {
      highestVal = { label: v.label, val: v.measureResult.currentValue };
    } else if (
      v.measureResult.currentValue &&
      v.measureResult.currentValue < 0 &&
      v.measureResult.currentValue < lowestVal.val
    ) {
      lowestVal = { label: v.label, val: v.measureResult.currentValue };
    }
  });
  topPositiveTile.value = highestVal.label;
  topNegativeTile.value = lowestVal.label;
});

const getBorderColour = (tileLabel: string) => {
  if (tileLabel == topPositiveTile.value) {
    return '#0c8a6599';
  } else if (tileLabel == topNegativeTile.value) {
    return '#D4002B80';
  } else {
    return;
  }
};
</script>
<template>
  <div class="flex flex-row w-full gap-20px">
    <ValueTile class="flex-grow" title="" :scores="[]" v-if="isLoadingIndicator" :loading="true"> </ValueTile>
    <MetricBreakdownTile
      v-else
      v-for="value in slicedValues"
      :style="{ width: `${100 / slicedValues!.length}%` }"
      :key="value.label"
      :title="value.label"
      :measureResult="value.measureResult"
      :metricBreakdown="value.metricBreakdown"
      :metricType="metricType!"
      :borderHighlight="getBorderColour(value.label)"
    />
  </div>
</template>
